import React from "react";
import { InfoModal } from "components";
import { formatUah, formatProcent } from "utils/format";

// Універсальний компонент для відображення або редагування однієї ціни
const PriceDisplay = ({
  isEditing,
  value,
  purchasePrice,
  getProfitInfo,
  onEditChange,
  onUpdateValue,
  handleKeyDown,
}) => {
  if (isEditing) {
    return (
      <input
        type="number"
        value={value}
        onChange={onEditChange}
        onBlur={onUpdateValue}
        onKeyDown={handleKeyDown}
        autoFocus
      />
    );
  }
  if (value === null) {
    return <span>---</span>;
  }
  return (
    <InfoModal info={getProfitInfo(value, purchasePrice)}>
      <span>{formatUah(value)}</span>
    </InfoModal>
  );
};

// Компонент ціни для відповідного рядка таблиці
const RecommendationTablePriceCell = ({
  item,
  fieldBase,
  managerPercent,
  editing,
  onStartEditing,
  onUpdateValue,
  onEditChange,
  onCancelEditing,
  isEditable,
  hasCashData,
  hasDebitData,
  customStyle,
}) => {
  const cashField = `cash_${fieldBase}`;
  const debitField = `debit_${fieldBase}`;
  const isEditingCash = editing.article === item.article && editing.field === cashField;
  const isEditingDebit =
    editing.article === item.article && editing.field === debitField;

  // Функція для визначення прибутку
  const getProfit = (currentPrice, purchasePrice) => {
    if (currentPrice === null || isNaN(currentPrice)) return [];

    const rawPrice = currentPrice - purchasePrice;
    const navarValue = currentPrice * managerPercent;

    return [
      {
        label: "Закупівельна ціна",
        value: formatUah(purchasePrice),
        requiredPermission: "recommendations:view-stocks",
      },
      {
        label: "Маржа",
        value: formatUah(rawPrice),
        requiredPermission: "recommendations:view-stocks",
      },
      {
        label: "Відсоток маржі",
        value: formatProcent(rawPrice / currentPrice),
        requiredPermission: "recommendations:view-stocks",
      },
      { label: "Прибуток менеджера", value: formatUah(navarValue) },
    ];
  };

  // Обробник клавіш
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onUpdateValue(); // Зберегти зміни
    } else if (e.key === "Escape") {
      onCancelEditing(); // Скасувати зміни
    }
  };

  return (
    <td className={`price split-cell ${customStyle}`}>
      <div className="split-cell-content">
        {/* Готівкова ціна */}
        {(hasCashData || isEditingCash) && (
          <div
            className="price-type-row"
            // Додаємо можливість редагування тільки якщо є дозвіл
            onDoubleClick={
              isEditable ? () => onStartEditing(item, cashField) : undefined
            }
          >
            <PriceDisplay
              isEditing={isEditingCash}
              value={isEditingCash ? editing.value : item[cashField]}
              purchasePrice={item.cash_purchase_price}
              getProfitInfo={getProfit}
              onEditChange={onEditChange}
              onUpdateValue={onUpdateValue}
              handleKeyDown={handleKeyDown}
            />
          </div>
        )}

        {/* Безготівкова ціна */}
        {(hasDebitData || isEditingDebit) && (
          <div
            className="price-type-row"
            onDoubleClick={
              isEditable ? () => onStartEditing(item, debitField) : undefined
            }
          >
            <PriceDisplay
              isEditing={isEditingDebit}
              value={isEditingDebit ? editing.value : item[debitField]}
              purchasePrice={item.debit_purchase_price}
              getProfitInfo={getProfit}
              onEditChange={onEditChange}
              onUpdateValue={onUpdateValue}
              handleKeyDown={handleKeyDown}
            />
          </div>
        )}
      </div>
    </td>
  );
};

export default RecommendationTablePriceCell;
